import { render, staticRenderFns } from "./CaseAvatar.vue?vue&type=template&id=46326a96&scoped=true&"
import script from "./CaseAvatar.vue?vue&type=script&lang=js&"
export * from "./CaseAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CaseAvatar.vue?vue&type=style&index=0&id=46326a96&scoped=true&lang=css&"
import style1 from "./CaseAvatar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46326a96",
  null
  
)

export default component.exports